/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/DialogFlowTemplateMessageReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./DialogFlowTemplateMessageReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DialogFlowTemplateReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.DialogFlowTemplateMessageReport);
  }
}(this, function(ApiClient, DialogFlowTemplateMessageReport) {
  'use strict';




  /**
   * The DialogFlowTemplateReport model module.
   * @module model/DialogFlowTemplateReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>DialogFlowTemplateReport</code>.
   * @alias module:model/DialogFlowTemplateReport
   * @class
   */
  var exports = function() {
    var _this = this;












  };

  /**
   * Constructs a <code>DialogFlowTemplateReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DialogFlowTemplateReport} obj Optional instance to populate.
   * @return {module:model/DialogFlowTemplateReport} The populated <code>DialogFlowTemplateReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Messages')) {
        obj['Messages'] = ApiClient.convertToType(data['Messages'], [DialogFlowTemplateMessageReport]);
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('WelcomeMessage')) {
        obj['WelcomeMessage'] = ApiClient.convertToType(data['WelcomeMessage'], 'String');
      }
      if (data.hasOwnProperty('EndMessage')) {
        obj['EndMessage'] = ApiClient.convertToType(data['EndMessage'], 'String');
      }
      if (data.hasOwnProperty('PreviewImageTaken')) {
        obj['PreviewImageTaken'] = ApiClient.convertToType(data['PreviewImageTaken'], 'Date');
      }
      if (data.hasOwnProperty('PreviewBlobStorageUrl')) {
        obj['PreviewBlobStorageUrl'] = ApiClient.convertToType(data['PreviewBlobStorageUrl'], 'String');
      }
      if (data.hasOwnProperty('DefaultPreviewBlobStorageUrl')) {
        obj['DefaultPreviewBlobStorageUrl'] = ApiClient.convertToType(data['DefaultPreviewBlobStorageUrl'], 'String');
      }
      if (data.hasOwnProperty('PromoteInAgendaHome')) {
        obj['PromoteInAgendaHome'] = ApiClient.convertToType(data['PromoteInAgendaHome'], 'Boolean');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/DialogFlowTemplateMessageReport>} Messages
   */
  exports.prototype['Messages'] = undefined;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} WelcomeMessage
   * @default ''
   */
  exports.prototype['WelcomeMessage'] = '';
  /**
   * @member {String} EndMessage
   * @default ''
   */
  exports.prototype['EndMessage'] = '';
  /**
   * @member {Date} PreviewImageTaken
   */
  exports.prototype['PreviewImageTaken'] = undefined;
  /**
   * @member {String} PreviewBlobStorageUrl
   * @default ''
   */
  exports.prototype['PreviewBlobStorageUrl'] = '';
  /**
   * @member {String} DefaultPreviewBlobStorageUrl
   * @default ''
   */
  exports.prototype['DefaultPreviewBlobStorageUrl'] = '';
  /**
   * @member {Boolean} PromoteInAgendaHome
   * @default false
   */
  exports.prototype['PromoteInAgendaHome'] = false;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


